import { Segment } from '../CommonInterfaces';
import { parseTextParams } from '../util/TextUtil';

export interface GaData {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: string;
}

export interface GaDataParams {
  [key: string]: string;
}

export class GaDataStore {
  public static ssoBaseGaProps = { event: 'SSOEvent', eventCategory: 'SSO' };

  public static push(data: GaData, params?: GaDataParams) {
    if (window.dataLayer) {
      const { eventCategory, eventLabel, eventAction } = data;
      const category = eventCategory && params ? parseTextParams(eventCategory, params) : eventCategory;
      const label = eventLabel && params ? parseTextParams(eventLabel, params) : eventLabel;
      const action = eventAction && params ? parseTextParams(eventAction, params) : eventAction;
      window.dataLayer.push({ ...data, eventCategory: category, eventAction: action, eventLabel: label });
    }
  }

  public static loginStatus(success: boolean, type: string, rememberMe: boolean) {
    const status = success ? 'Success' : 'Failed';
    const remeberMeText = rememberMe ? 'Yes' : 'No';
    GaDataStore.push({ ...this.ssoBaseGaProps, eventAction: 'Login', eventLabel: `${status} - Login option: ${type} - Remember me: ${remeberMeText}` });
  }

  public static selectMandate(segment: Segment) {
    GaDataStore.push({ ...this.ssoBaseGaProps, eventAction: 'Representee', eventLabel: `Select Mandate - ${segment}` });
  }

  public static searchMandate() {
    GaDataStore.push({ ...this.ssoBaseGaProps, eventAction: 'Representee', eventLabel: 'Search - Text Field Filled' });
  }

  public static registerB2B() {
    GaDataStore.push({ ...this.ssoBaseGaProps, eventAction: 'Representee', eventLabel: 'Uue ärikliendi registreerimine' });
  }

  public static emailAdditionalButton(buttonText: string) {
    GaDataStore.push({ ...this.ssoBaseGaProps, eventAction: 'Login', eventLabel: `Email - ${buttonText}` });
  }

  public static logout() {
    GaDataStore.push({ ...this.ssoBaseGaProps, eventAction: 'Logout', eventLabel: 'Logout' });
  }

  public static error(message: string) {
    GaDataStore.push({ ...this.ssoBaseGaProps, eventAction: window.location.pathname, eventLabel: `Veateade - ${message}` });
  }

  public static openModuleView() {
    GaDataStore.push({ event: 'SSOLoadedEvent' });
  }
}

export default GaDataStore;
